module.exports = __webpack_public_path__ + "static/020.thumb-4a124e7fd60f880e13cc8bf317677385.jpg";